export default {
  lang: 'English',
  // QQ表情
  "qqface_Smile": "Smile",
  "qqface_Grimac": "Grimac",
  "qqface_Drool": "Drool",
  "qqface_Scowl": "Scowl",
  "qqface_Chill": "Chill",
  "qqface_Sob": "Sob",
  "qqface_Shy": "Shy",
  "qqface_Silent": "Silent",
  "qqface_Sleep": "Sleep",
  "qqface_Cry": "Cry",
  "qqface_Awkward": "Awkward",
  "qqface_Angry": "Angry",
  "qqface_Tongue": "Tongue",
  "qqface_Grin": "Grin",
  "qqface_Surprise": "Surprise",
  "qqface_Frown": "Frown",
  "qqface_CoolGuy": "CoolGuy",
  "qqface_Helpless": "Helpless",
  "qqface_Scream": "Scream",
  "qqface_Puke": "Puke",
  "qqface_Chuckle": "Chuckle",
  "qqface_Joyful": "Joyful",
  "qqface_Slight": "Slight",
  "qqface_Smug": "Smug",
  "qqface_Hungry": "Hungry",
  "qqface_Drowsy": "Drowsy",
  "qqface_Panic": "Panic",
  "qqface_Sweat": "Sweat",
  "qqface_Laugh": "Laugh",
  "qqface_Commando": "Commando",
  "qqface_Determined": "Determined",
  "qqface_Scold": "Scold",
  "qqface_Confused": "Confused",
  "qqface_Shhh": "Shhh",
  "qqface_Dizzy": "Dizzy",
  "qqface_Torturing": "Torturing",
  "qqface_Toasted": "Toasted",
  "qqface_Skull": "Skull",
  "qqface_Hammer": "Hammer",
  "qqface_Bye": "Bye",
  "qqface_Speechless": "Speechless",
  "qqface_NosePick": "NosePick",
  "qqface_Clap": "Clap",
  "qqface_Embarrased": "Embarrased",
  "qqface_Trick": "Trick",
  "qqface_Hum!L": "Hum!L",
  "qqface_Hum!R": "Hum!R",
  "qqface_Yawn": "Yawn",
  "qqface_Pooh-pooh": "Pooh-pooh",
  "qqface_Shrunken": "Shrunken",
  "qqface_TearingUp": "TearingUp",
  "qqface_Sly": "Sly",
  "qqface_Kiss": "Kiss",
  "qqface_What!": "What!",
  "qqface_Whimper": "Whimper",
  "qqface_Cleaver": "Cleaver",
  "qqface_Watermelon": "Watermelon",
  "qqface_Beer": "Beer",
  "qqface_Basketball": "Basketball",
  "qqface_Pingpong": "Pingpong",
  "qqface_Coffee": "Coffee",
  "qqface_Rice": "Rice",
  "qqface_Pig": "Pig",
  "qqface_Rose": "Rose",
  "qqface_Wilt": "Wilt",
  "qqface_Lips": "Lips",
  "qqface_Heart": "Heart",
  "qqface_BrokenHeart": "BrokenHeart",
  "qqface_Cake": "Cake",
  "qqface_Lightning": "Lightning",
  "qqface_Bomb": "Bomb",
  "qqface_Knife": "Knife",
  "qqface_Football": "Football",
  "qqface_Beetle": "Beetle",
  "qqface_Poop": "Poop",
  "qqface_Moon": "Moon",
  "qqface_Sun": "Sun",
  "qqface_Gift": "Gift",
  "qqface_Hug": "Hug",
  "qqface_Thumbsup": "Thumbsup",
  "qqface_Thumbsdown": "Thumbsdown",
  "qqface_Shake": "Shake",
  "qqface_Victory": "Victory",
  "qqface_Salute": "Salute",
  "qqface_Beckon": "Beckon",
  "qqface_Fist": "Fist",
  "qqface_Bad": "Bad",
  "qqface_LoveYou": "LoveYou",
  "qqface_NO": "NO",
  "qqface_OK": "OK",
  "qqface_Love": "Love",
  "qqface_Blow_a_kiss": "Blow a kiss",
  "qqface_Waddle": "Waddle",
  "qqface_Tremble": "Tremble",
  "qqface_Aaagh!": "Aaagh!",
  "qqface_Twirl": "Twirl",
  "qqface_Kowtow": "Kowtow",
  "qqface_Turn_round": "Turn round",
  "qqface_Rope_Skipping": "Rope Skipping",
  "qqface_Wave_hand": "Wave hand",
  "qqface_Excited": "Excited",
  "qqface_Street_Dance": "Street Dance",
  "qqface_Give_a_kiss": "Give a kiss",
  "qqface_Tai_Chi_L": "Tai Chi L",
  "qqface_Tai_Chi_R": "Tai Chi R",
  "qqface_Bliss": "Bliss",
  "qqface_Firecracker": "Firecracker",
  "qqface_Lantern": "Lantern",
  "qqface_Fortune": "Fortune",
  "qqface_Karaoke": "Karaoke",
  "qqface_Shopping": "Shopping",
  "qqface_Email": "Email",
  "qqface_Handsome": "Handsome",
  "qqface_Hurray": "Hurray",
  "qqface_Pray": "Pray",
  "qqface_Furious": "Furious",
  "qqface_Lollipop": "Lollipop",
  "qqface_Drink_milk": "Drink milk",
  "qqface_Noodles": "Noodles",
  "qqface_Banana": "Banana",
  "qqface_Plane": "Plane",
  "qqface_Driving": "Driving",
  "qqface_Highspeed_Rail_L": "Highspeed Rail L",
  "qqface_Carriage": "Carriage",
  "qqface_Highspeed_Rail_R": "Highspeed Rail R",
  "qqface_Cloudy": "Cloudy",
  "qqface_Rainy": "Rainy",
  "qqface_Cash": "Cash",
  "qqface_Panda": "Panda",
  "qqface_Light_bulb": "Light bulb",
  "qqface_Windmill": "Windmill",
  "qqface_Alarm_Clock": "Alarm Clock",
  "qqface_Umbrella": "Umbrella",
  "qqface_Balloon": "Balloon",
  "qqface_Ring": "Ring",
  "qqface_Sofa": "Sofa",
  "qqface_Toilet_Paper": "Toilet Paper",
  "qqface_Medicine": "Medicine",
  "qqface_Pistol": "Pistol",
  "qqface_Frog": "Frog",
  "custom_Face": "Custom Expression",
  // 通用UI展示信息
  "common_page_title": "Online customer service",
  "common_sendbtn_text": "Send",
  "common_voicebtn_hold_text": "Hold to Talk",
  "common_voicebtn_release_text": "Release to send",
  "common_voicebtn_cancel_text": "Release to cancel",
  "common_insert_photo_text": "Insert photo",
  "common_insert_emoji_text": "Insert emoji",
  "common_manual_close_text": "Quit chat",
  "common_insert_file_text": "Insert file",
  "common_feed_back_text": "feedback",
  "common_screenshot_text": 'screenshot',
  "common_screenshot_tip_QQ": "QQ/WeChat screenshot is recommended",
  "common_screenshot_tip_mac": "Mac: shortcut key Shift+Command+4 screenshot",
  "common_screenshot_tip_win": 'Windows: Use the built-in "screenshot tool"',
  "short_insert_photo_text": "Photo",
  "short_insert_file_text": "File",
  //英文文案未确定 需求也没有提及国际化 故先去掉英文tips
  // "common_insert_call_text": "Began to talk",
  // "common_insert_audo_text": "Artificial service",
  "common_insert_businessCard_text": "Send business card",
  "common_insert_businessCard_balloon_text": "Send My Business Card",
  "common_postarea_pc_placeholder": "Press \"Enter\" to send message, \"Ctrl + Enter\" change to new line",
  "common_postarea_Macpc_placeholder": "Press \"Enter\" to send message, \"Command + Enter\" change to new line",
  "common_postarea_mobile_placeholder": "Please enter",
  "common_chatting_text": "Chatting",
  "common_leave_message_text": "Message",
  "common_chatting_with_text": "Chatting with $1",
  "common_qq_chat_text": "QQ Chat",
  "common_start_qq_chat_text": "Start QQchat",
  "common_new_message_text": "New message",
  "common_add_qq_friend_text": "Add QQ friends",
  "common_confirm_text": "Confirm",
  "common_cancel_text": "Cancel",
  "common_tencent_certification": "certification-en",
  "common_lang_en": "English",
  "common_lang_zh": "Chinese",
  "common_lang_zh-TW": "Traditional Chinese",
  "common_tencent_translator": "Mr.Translator Auto Translation",
  "common_tencent_translator_fail": "Translation failure-Mr.Translator",
  "common_tencent_translator_only": "Only Chinese-English translation is supported-Mr.Translator",
  "common_allow_text": "Allow",
  "common_not_allow_text": "Don't Allow",
  "common_read_all": "Read All",
  "common_typing": "Typing...",
  "common_typing_human": "[Typing...]",
  "common_view_all": "Click to view all",
  "common_audio_text": "Audio call",
  "common_video_text": "Video call",
  "common_video_confirm": "I see",
  "common_video_text_call": "To call",

  // 聊天相关信息
  "chat_max_post_limit_text": "Content exceeds text limit",
  "chat_history_msg_get_text": "Click to load historical messages",
  "chat_history_msg_get_error": "Failed to load history message",
  "chat_history_msg_loading_text": "Loading historical messages",
  "chat_offline_msg_loading_text": "Loading new messages",
  "chat_offline_msg_fail_text": "Fail to receive new messages, please click to retry",
  "chat_offline_msg_over_text": "New message",
  "chat_menu_msg_loading_text": "Loading navigation",
  "chat_menu_msg_fail_text": "Fail to receive navigation, click to retry",
  "chat_menu_msg_history_expired_text": "Historical messages has expired",
  "chat_graphic_msg_readmore_text": "Read more",
  "chat_graphic_msg_viewdmore_text": "View more",

  "chat_feedback_title_text": "Please rate for the service",
  "chat_feedback_submit_text": "Submit",
  "chat_feedback_postarea_placeholder": "Your advice is mostly welcomed :)",
  "chat_feedback_submitting_text": "Submitting",
  "chat_feedback_success_msg": "Submitted successfully",
  "chat_feedback_fail_msg": "Submission Failed",
  "chat_feedback_error_msg": "Network error, please try again",
  "chat_feedback_very_dissatisfied_text": "Very Dissatisfied",
  "chat_feedback_dissatisfied_text": "Dissatisfied",
  "chat_feedback_neutral_text": "Neutral",
  "chat_feedback_satisfied_text": "Satisfied",
  "chat_feedback_very_satisfied_text": "Very Satisfied",

  "chat_add_friend_fetching_protocol_msg": "Fetching protocol",
  "chat_add_friend_copy_success_msg": "Successful copy",
  "chat_add_friend_fail_text": "Fail",
  "chat_add_friend_fail_get_number_fail_text": "Failed to get numerical data",
  "chat_add_friend_fail_no_text_selected_text": "No text selected, please copy it manually",
  "chat_add_friend_fail_browser_not_support_text": "Browser does not support, please copy it manually",
  "chat_change_queue_immediately": '立即切换',
  "chat_close_session_confirm": "After ending the session, you may need to queue up again for consultation. Are you sure to end the session?",
  "chat_close_session_succ": "The session has ended. If you need to continue the service, please send a message directly",

  "chat_incoming": "Accessing, please wait",
  "chat_incoming_success": "Successful connection",
  "chat_incoming_timeout": "Access fails, please <a class=\"btn-refresh\" href=\"javascript:;\" onclick=\"location.reload();\">refresh</a> to try again",
  "chat_incoming_timeout_inframe": "Access fails, please refresh to try again",

  // 系统消息
  "sysmsg_load_corpinfo_msg": "Loading business information",
  "sysmsg_load_corpinfo_fail_msg": "Failed to load business information",
  // 员工信息
  "sysmsg_load_staff_msg": "Loading staff information",
  "sysmsg_load_staff_fail_msg": "Failed to load staff information",

  // 退出排队
  "exit_queque_btn": "Exit queue",
  "exit_queue_confirm": "Are you sure to exit the current queue?",
  "exit_queue_success": "You have exited the queue",
  "exit_queue_fail": "Failed to exit the queue. Please try again",

  // 顶部通知
  "notice_slider_header": "【Noice】",
  "notice_popup_header": "Public Notice",
  "notice_item_header": "【Noice】",
  "notice_item_header_gjh": "【Noice】",

  // 电商
  "ec_goods_text": "Goods",
  "ec_order_text": "Order",

  //发送名片按钮
  "send_business_card_btn":'send business card',

   // xml结构化消息
   "xml_product_name": "Product Name",
   "xml_product_exhibition_area": "Exhibition Area",
   "xml_product_category": "Product Category",

   "xml_purchase_quantity": "Purchase Quantity",
   "xml_purchase_unit": "Purchase Unit",

   "xml_buyer_name": "Buyer Name",
   "xml_buyer_location": "Buyer Location",
   "xml_buyer_tag": "Buyer Tag",

   "xml_source_product":"Source Product",
   "xml_source_category":"Category",
   "xml_source_detail":"Details",
   "xml_buyer_company_name":"Buyer Company Name",
   "xml_buyer_company_country":"Country /Region",
   
   "xml_exhibit_name":"Product Name",
   "xml_exhibit_uom":"Uom",
   "xml_exhibit_price":'Price',
   "xml_exhibit_currency":"Currency",
   "xml_exhibit_detail":"Details",

   "xml_exhibit_jump_tip":"Click to view detailed purchase intention",
   "sysmsg_msg_current_service_lang": "The service language is ",
   "sysmsg_msg_change_service_lang": "Service language changed to ",


  // 消息已读回执
  "msg_unread": "Unread",
  "msg_beenread": "Read",
};
